<template>
  <v-row>
    <v-col>
      <v-img :id="id" :src="img" aspect-ratio="1.7">
      </v-img>
      <v-row>
        <v-col>
          <span class="text-uppercase text-tcdc-green sub-header1 bold">{{ name }}</span>
        </v-col>
        <v-col v-if="isHighlight" class="text-tcdc-green d-flex flex-1 align-center justify-end">
          <img src="../../assets/icons/sorts/resource_center.png" class="branch-card-logo pr-2" />
          <img src="../../assets/icons/sorts/consult.png" class="branch-card-logo pr-2" />
          <img src="../../assets/icons/sorts/venture_hire.png" class="branch-card-logo pr-2" />
          <img src="../../assets/icons/sorts/membership.png" class="branch-card-logo pr-2" />
        </v-col>
      </v-row>
      <Divider />
      <v-row v-if="!isHighlight">
        <v-col class="text-left text-tcdc-green d-flex flex-1 align-center">
          <img src="../../assets/icons/sorts/resource_center.png" class="branch-card-logo pr-2" />
          <img src="../../assets/icons/sorts/consult.png" class="branch-card-logo pr-2" />
          <img src="../../assets/icons/sorts/venture_hire.png" class="branch-card-logo pr-2" />
          <img src="../../assets/icons/sorts/membership.png" class="branch-card-logo pr-2" />
        </v-col>
      </v-row>
      <Divider v-if="!isHighlight" />
    </v-col>
  </v-row>
</template>

<script>
import Divider from "../../components/dividers/Divider";
export default {
  props: {
    id : {
      type: Number,
      default: 1
    },
    img : {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    },
    place: {
      type: String,
      default: ""
    },
    isHighlight: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Divider
  }
};
</script>

<style>
.branch-card-logo {
  height: 25px;
  object-fit: contain;
}
</style>
